import { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Listable } from 'listable'
import { useNavigate } from 'react-router-dom'
import { useSettingsFleetValues } from 'features/settings'
import Row from './row'
import Filters from '../filters'
import { encodeUserId } from 'features/admin-users/utils'
import { actions, config, constants } from '../../module'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

const List = ({ model, userRoles, onRequestRoles, onReset, onDelete }) => {

  const navigate = useNavigate()
  const fleets = useSettingsFleetValues()

  const renderItem = useCallback((item, index, itemProps) => {

    const onView = () => navigate(`${constants.PATH_SINGLE}/${encodeUserId(item.id)}`)

    return (
      <Row
        key={index}
        item={item}
        fleets={fleets}
        onView={onView}
        userRoles={userRoles}
        onDelete={onDelete}
        {...itemProps}/>
    )
  }, [fleets, navigate, userRoles, onDelete])

  // Prevents re-rendering if ids or data updated - no longer needed
  const { ids, filters, ...rest } = model

  useEffect(() => {
    onReset()
    onRequestRoles()
  }, [onReset, onRequestRoles])

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '100%',
        width: '100%',
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          width: '100%',
          overflowX: 'auto',

          padding: 2,
        }}>
        <Listable
          actions={actions}
          config={config}
          filters={Filters}
          model={rest}
          renderItem={renderItem}
          actionButtons={
            <Stack
              flexDirection={{ xs: 'column', md: 'row' }}
              justifyContent='space-between'
              gap={1}>
              <Stack flexDirection="row" gap={2}>
                <Box width={{ xs: '100%', md: '180px' }}>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={() => navigate(constants.PATH_ADD)}>
                    {'Add User'}
                  </Button>
                </Box>
              </Stack>
            </Stack>
          }/>
      </Box>
    </Box>

  )
}

List.propTypes = {
  model: PropTypes.object.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRequestRoles: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

const mapStateToProps = ({ adminInvitations, settings, account }) => ({
  model: adminInvitations,
  userRoles: settings.roles,
})

const mapDispatchToProps = (dispatch) => ({
  onRequestRoles: () => {
    dispatch(actions.requestRoles())
  },
  onReset: () => {
    dispatch(actions.reset())
  },
  onDelete: (userId) => {
    console.log('Delete userId ', userId)
    dispatch(actions.requestRemoveUser(null, {
      resourceId: userId
    }))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List)
